const TAB_ELEMENT_CLASS = 'tab';
const TAB_CONTENT_CLASS = 'tabcontent';
const TAB_LINK_CLASS = 'tablink';
const TAB_LINK_ACTIVE_CLASS = 'tablink--active';

const openTab = (tabButton) => {
    const tabId = tabButton.dataset.tabId;
    const tabcontentElements = document.getElementsByClassName(TAB_CONTENT_CLASS);
    const tablinkElements = document.getElementsByClassName(TAB_LINK_CLASS);

    if (!tabcontentElements || tabcontentElements.length === 0 || !tablinkElements || tablinkElements.length === 0) {
        return;
    }

    for (let i = 0; i < tabcontentElements.length; i++) {
        tabcontentElements[i].classList.remove('tabcontent--selected');
    }

    for (let i = 0; i < tablinkElements.length; i++) {
        tablinkElements[i].className = tablinkElements[i].className.replace(` ${TAB_LINK_ACTIVE_CLASS}`, "");
    }

    const tabElement = document.getElementById(tabId);
    if (tabElement) {
        tabElement.classList.add('tabcontent--selected');
    }

    tabButton.className += ` ${TAB_LINK_ACTIVE_CLASS}`;
}

const registerTabButtons = (tabButtons) => {
    for (const tabButton of tabButtons) {
        const isSelected = tabButton.dataset.isSelected;

        if (isSelected === 'true') {
            openTab(tabButton);
        }

        tabButton.addEventListener('click', () => openTab(tabButton));
    }
}

export const initTabs = () => {
    const tabElements = document.getElementsByClassName(TAB_ELEMENT_CLASS);

    if (!tabElements || tabElements.length === 0) {
        return;
    }

    for (const tabElement of tabElements) {
        const tabButtons =  tabElement.querySelectorAll("button");
        if (!tabButtons || tabButtons.length === 0) {
            return;
        }

        registerTabButtons(tabButtons);
    }
}
